
import { Loader, LoaderOptions } from "@googlemaps/js-api-loader";
import {} from "googlemaps";
import i18n from '@/i18n';


export const initalizeGoogleMaps = (() => {
  const loaderOptions: LoaderOptions = {
    apiKey: process.env.VUE_APP_GMAPS_KEY!,
    // PALIATIVO: a Drawing Library (google.maps.drawing.DrawingManager) foi removida da Maps JS API
    // a partir da 3.65 (https://developers.google.com/maps/deprecations). Os canais "weekly" e
    // "quarterly" já servem a 3.65+, o que quebra PolygonDrawer e CropDrawer. A 3.64 ainda serve a
    // biblioteca, mas o Google mantém só as 4 últimas versões numeradas: quando a 3.64 for aposentada
    // (previsão: ~fev/2027), a requisição cai no canal padrão e o erro volta. Migrar o desenho de
    // polígonos para uma alternativa (ex.: Terra Draw) antes disso.
    version: "3.64",
    libraries: ["places", "drawing"],
    language: i18n.t("core.wrapped-gm.language") as string,
    region: i18n.t("core.wrapped-gm.region") as string,
  };

  const deferred: Array<() => any> = [];

  function deferCb(fn: () => any) {
    deferred.push(fn);
  }

  async function callDeferred() {
    await Promise.all(deferred.map(async (fn) => await fn()));
  }

  return async function loadMaps(afterLoad: () => any) {
    if (!!window.google) {
      try {
        await afterLoad();
      } catch {}
    } else {
      deferCb(afterLoad);
      if (deferred.length <= 1) {
        await new Loader(loaderOptions).load();
        requestAnimationFrame(callDeferred);
      }
    }
  }
}) ();

